import { useTranslation } from 'react-i18next'

import { UserMultiValueContent } from '../UserMultiValueContent'

import { getUserMultiValueName } from './UserMultiValue.utils'

function UserMultiValue({
  Content = UserMultiValueContent,
  user,
  ...restProps
}) {
  const { t } = useTranslation()

  const name = getUserMultiValueName({ t, user })

  return name ? <Content {...restProps} name={name} user={user} /> : null
}

export default UserMultiValue
